// import React, { useEffect } from "react";
// import "./WhyChooseUs.css";
// import { FaThumbsUp, FaLock, FaBolt, FaUsers } from "react-icons/fa";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const reasons = [
//   {
//     icon: <FaThumbsUp />,
//     title: "Proven Expertise",
//     description:
//       "Our experienced team has successfully delivered projects across various industries. We bring deep domain knowledge, proven methodologies, and technical excellence to every solution we create.",
//   },
//   {
//     icon: <FaLock />,
//     title: "Strong Security",
//     description:
//       "Security is at the heart of everything we build. From encrypted data handling to secure deployments, we follow best practices to ensure your product is always protected.",
//   },
//   {
//     icon: <FaBolt />,
//     title: "Fast Delivery",
//     description:
//       "Our agile approach enables us to deliver fast without compromising on quality. We use efficient processes, regular sprints, and continuous feedback to keep projects moving quickly.",
//   },
//   {
//     icon: <FaUsers />,
//     title: "Client-Centric Approach",
//     description:
//       "We believe in building strong relationships through transparency, collaboration, and support. Your success is our priority, and we tailor every solution to match your goals.",
//   },
// ];

// const WhyChooseUs = () => {
//   useEffect(() => {
//     AOS.init({
//       duration: 1000, 
//       once: true, 
//     });
//   }, []);

//   return (
//     <section className="why-section" id="whychooseus">
//       <div className="why-header" data-aos="fade-up">
//         <h2 className="why-title">Why Choose Us</h2>
//         <div className="why-underline"></div>
//       </div>
//       <div className="why-grid">
//         {reasons.map((reason, index) => (
//           <div
//             className="why-card"
//             key={index}
//             data-aos="fade-up"
//             data-aos-delay={index * 200} 
//           >
//             <div className="why-icon">{reason.icon}</div>
//             <h3 className="why-card-title">{reason.title}</h3>
//             <p className="why-card-description">{reason.description}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default WhyChooseUs;




import React, { useEffect } from "react";
import "./WhyChooseUs.css";
import { FaThumbsUp, FaLock, FaBolt, FaUsers } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

const reasons = [
  {
    icon: <FaThumbsUp />,
    title: "Proven Expertise",
    description:
      "Our experienced team has successfully delivered projects across various industries. We bring deep domain knowledge, proven methodologies, and technical excellence to every solution we create.",
  },
  {
    icon: <FaLock />,
    title: "Strong Security",
    description:
      "Security is at the heart of everything we build. From encrypted data handling to secure deployments, we follow best practices to ensure your product is always protected.",
  },
  {
    icon: <FaBolt />,
    title: "Fast Delivery",
    description:
      "Our agile approach enables us to deliver fast without compromising on quality. We use efficient processes, regular sprints, and continuous feedback to keep projects moving quickly.",
  },
  {
    icon: <FaUsers />,
    title: "Client-Centric Approach",
    description:
      "We believe in building strong relationships through transparency, collaboration, and support. Your success is our priority, and we tailor every solution to match your goals.",
  },
];

const WhyChooseUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out-back",
    });
  }, []);

  return (
    <section className="why-section" id="whychooseus">
      <div className="why-header" data-aos="fade-up">
        <h2 className="why-title">Why Choose Us</h2>
        <div className="why-underline"></div>
      </div>
      <div className="why-grid">
        {reasons.map((reason, index) => (
          <div
            className="why-card"
            key={index}
            data-aos="zoom-in"
            data-aos-delay={index * 200}
          >
            <div className="why-icon">{reason.icon}</div>
            <h3 className="why-card-title">{reason.title}</h3>
            <p className="why-card-description">{reason.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
